import axios from 'axios'

class Api {

  constructor (url, key) {
    this.url = url
    this.key = key
    this.instance = axios.create({
      baseURL: url,
      headers: {'X-Api-Key': key}
    });
  }

  get (path, params) {
    if (!this.key) return
    return this.instance.get(path, {params: params}).then(r => r.data)
      .catch(error => {
        // console.log(error)
        if (error.response.status === 401) {
          alert('Invalid API key')
        }
        return {}
      })
  }

  put (path, params) {
    if (!this.key) return
    var formData = new FormData()
    for (var param in params) {
      formData.set(param, params[param])
    }
    return this.instance.put(path, formData).then(r => r.data)
  }

  post (path, params) {
    if (!this.key) return
    var formData = new FormData()
    for (var param in params) {
      formData.set(param, params[param])
    }
    return this.instance.post(path, formData).then(r => r.data)
  }

  delete (path) {
    if (!this.key) return
    return this.instance.delete(path).then(r => r.data)
  }

  download (path, filename) {
    if (!this.key) return
    axios({
      url: this.url + path,
      method: 'GET',
      headers: {'X-Api-Key': this.key},
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    });
  }

}

export default Api
